import { render, staticRenderFns } from "./TemplateSettingComp.vue?vue&type=template&id=100c4a42"
import script from "./TemplateSettingComp.vue?vue&type=script&lang=js"
export * from "./TemplateSettingComp.vue?vue&type=script&lang=js"
import style0 from "./TemplateSettingComp.vue?vue&type=style&index=0&id=100c4a42&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports